<template>
<div class="md-layout">
  <div class="login-wrapper md-layout-item md-size-60 md-large-size-50 md-small-size-100 md-elevation-5">
    <form novalidate class="md-layout" @submit.prevent="() => false">
      <md-card class="md-layout-item">
        <md-card-content>
          <span class="md-title">{{ title }}</span>
          <slot></slot>
        </md-card-content>
      </md-card>
    </form>
  </div>
</div>
</template>

<script>
export default {
  props: ['title']
  
}
</script>

<style>
.login-wrapper {
    background-color: #312452;
    padding-top: 2em;
    color: white;
    padding: 0;
    padding-top: 4px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5em;
    border-radius: 5px;
    h2 {
        margin: 1.5em;
    }
    
}
</style>
